import { Stack, Text } from "@bps/fluent-ui";

import { ErrorResult } from "../../api/base";
import { VerifyPinFormError } from "./VerifyPinFormError";
import { VerifyPinFormHeader } from "./VerifyPinFormHeader";

interface VerifyPinFormTooManyAttemptsProps {
  error: ErrorResult;
}

export const VerifyPinFormTooManyAttempts = ({
  error
}: VerifyPinFormTooManyAttemptsProps) => {
  return (
    <Stack tokens={{ childrenGap: 24 }}>
      <VerifyPinFormHeader />
      <VerifyPinFormError error={error} />
      <Stack tokens={{ childrenGap: 16 }}>
        <Text>For security reasons, the form has been locked</Text>
        <Text>
          Contact your practice to confirm your date of birth is correct and
          resend the form
        </Text>
      </Stack>
    </Stack>
  );
};
